import { ClickPortalNavItem } from 'types';

export interface AcfNavItem {
  link?: {
    title?: string;
    url?: string;
    target?: string;
  };
  label?: string;
  url?: string;
  target?: string;
}

export function transformPortalResultsNavItems(
  navItems: AcfNavItem[] | undefined
): ClickPortalNavItem[] {
  if (!Array.isArray(navItems)) {
    return [];
  }

  return navItems.reduce<ClickPortalNavItem[]>((items, item) => {
    const label = item.link?.title || item.label || '';
    const url = item.link?.url || item.url || '';
    const target = item.link?.target || item.target || '';

    if (!label || !url) {
      return items;
    }

    items.push({ label, url, target });
    return items;
  }, []);
}
